import { render, staticRenderFns } from "./DeveloperInfo.vue?vue&type=template&id=22d7c274&scoped=true&"
import script from "./DeveloperInfo.vue?vue&type=script&lang=js&"
export * from "./DeveloperInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeveloperInfo.vue?vue&type=style&index=0&id=22d7c274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d7c274",
  null
  
)

/* custom blocks */
import block0 from "./DeveloperInfo.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports